import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
    providedIn: 'root'
  })
  export class ErrorLogService{
      constructor(
          private http: HttpClient,
          private apiService: ApiService
      ) { }

      public getIndividualNLogRecordDetails(id:number):Observable<any> {
        return this.apiService.getInd(`NLog/${id}`)
      }
      public searchErrorLogReport(errorLogReportSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(errorLogReportSearchParam);
        return this.apiService.post(`NLog/SearchNLog`,errorLogReportSearchParam)
      }
      // public searchErrorLogReport(errorLogReportSearchParam:IGlobalSearchParam):Observable<any> {
      //   console.log(errorLogReportSearchParam);
      //   return this.apiService.post(`ErrorLog/SearchErrorLogReport`,errorLogReportSearchParam)
      // }
      public exportErrorLogReport(errorLogReportSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}NLog/ExportNLog`,
        errorLogReportSearchParam ,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  }